var searchGrids = document.querySelectorAll('.search-grid');

if (searchGrids.length > 0) {

    var originalSearchParameters = new URLSearchParams(window.location.search);

    var allowedParams = {
        type: "type",
        subtype: "custom_field.subType_fr_FR_sortable.raw",
        searchParam: "searchParameterId",
        query: "q"
    }

    var allowedTypeValues = {
        film: "W9Q0",
        person: "Z4V9",
        archive: "I0M6",
        imprime: "N9W5",
        video: "V1M1",
        image: "M5L0"
    }

    searchGrids.forEach(searchGrid => {

        initSearchDisplay(searchGrid);

        initExport(searchGrid);

        initReset();

        initSearchBar();

        initSort()

        var radios = document.querySelectorAll('input[name="search-type"]');
        if (radios !== null) {
            initSearchObjects();
        }

    })
}


function initSearchBar() {
    var searchBar = document.getElementById('search-bar-catalogue');

    if (searchBar) {
        var searchCheckbox = document.getElementById('search-checkbox');
        var searchTextInput = document.getElementById('search-bar-keywords-input');
        var searchTextInputLiferay = document.getElementById('search-bar-keywords-input-lr');

        var initialValue = searchTextInputLiferay.value.trim();
        var regex = /^".*"$/;

        // Si la valeur du champ Liferay à l'initialisation commence et fini ET finit par ", on coche la case et retire les guillemets pour l'ajouter au champ visible
        if (regex.test(initialValue)) {
            searchCheckbox.checked = true;
            var contentWithoutQuotes = initialValue.replace(/^"(.*)"$/, '$1');
            searchTextInput.value = contentWithoutQuotes;
        } else {
            searchTextInput.value = initialValue;
        }

        searchCheckbox.addEventListener('change', () => {
            var value = searchTextInputLiferay.value.trim() ?? '';
            var contentWithoutQuotes = value.replace(/^"(.*)"$/, '$1');
            if (searchCheckbox.checked) {
                searchTextInputLiferay.value = `"${contentWithoutQuotes}"`;
            } else {
                searchTextInputLiferay.value = contentWithoutQuotes;
            }
        })

        searchTextInput.addEventListener('input', () => {
            if (searchCheckbox.checked) {
                searchTextInputLiferay.value = `"${searchTextInput.value}"`;
            } else {
                searchTextInputLiferay.value = searchTextInput.value;
            }
        });

        var searchSubmit = searchBar.querySelector('button[type="submit"]');
        searchSubmit.addEventListener('click', (e) => {
            var keywordQuery = searchTextInputLiferay.value;
            var searchForm = searchBar.closest('form');
            var action = searchForm.getAttribute('action');
            if (keywordQuery) {
                e.preventDefault();
                var newQuery = new URL(action, window.location.origin);
                newQuery.searchParams.set(allowedParams.query, keywordQuery);
                window.location.href = newQuery.toString();
            }
        })
    }
}

var searchChangeConfirmationModal = null;

function openSearchChangeConfirmationModal() {
    if (searchChangeConfirmationModal) {
        searchChangeConfirmationModal.remove();
        searchChangeConfirmationModal = null;
    }

    return new Promise(resolve => {
        var overlay = document.createElement('div');
        overlay.className = 'tw:fixed tw:inset-0 tw:z-[1000] tw:flex tw:items-center tw:justify-center tw:p-4';

        var backdrop = document.createElement('div');
        backdrop.className = 'tw:absolute tw:inset-0 tw:bg-text tw:opacity-90 tw:cursor-default';
        backdrop.setAttribute('aria-hidden', 'true');

        var dialog = document.createElement('div');
        dialog.className = 'js-search-change-confirmation tw:relative tw:z-[1001] tw:w-full tw:max-w-[41.25rem] tw:bg-white tw:shadow-xl tw:overflow-hidden tw:rounded-xs';
        dialog.setAttribute('role', 'dialog');
        dialog.setAttribute('aria-modal', 'true');
        dialog.setAttribute('aria-labelledby', 'search-change-confirmation-title');
        dialog.setAttribute('aria-describedby', 'search-change-confirmation-description');

        var header = document.createElement('div');
        header.className = 'tw:flex tw:items-center tw:justify-between tw:bg-prim tw:px-10 tw:py-[0.375rem] tw:text-white';

        var title = document.createElement('h2');
        title.id = 'search-change-confirmation-title';
        title.className = 'tw:text-h2/[2.8125rem] tw:font-title';
        title.textContent = 'Changer de type de notice ?';

        var closeButton = document.createElement('button');
        closeButton.type = 'button';
        closeButton.className = 'tw:group tw:ml-4 tw:cursor-pointer';
        closeButton.setAttribute('aria-label', 'Fermer');
        closeButton.innerHTML = '<span class="icon-cross tw:block tw:transition-all tw:text-base tw:text-white tw:group-hover:-rotate-90" aria-hidden="true"></span>';

        header.appendChild(title);
        header.appendChild(closeButton);

        var body = document.createElement('div');
        body.className = 'tw:px-[1.25rem] tw:pt-10 tw:pb-10 tw:xl:px-10';

        var description = document.createElement('p');
        description.id = 'search-change-confirmation-description';
        description.className = 'tw:text-[0.875rem]/[1.375rem]';
        description.textContent = 'Vous avez des filtres de recherche sélectionnés. En changeant de type de notice, ces filtres seront réinitialisés. Souhaitez-vous poursuivre ?';

        body.appendChild(description);

        var footer = document.createElement('div');
        footer.className = 'tw:px-[1.25rem] tw:pb-[1.25rem] tw:flex tw:flex-col tw:items-stretch tw:gap-3 tw:xl:px-10 tw:xl:flex-row tw:xl:justify-end';

        var okButton = document.createElement('button');
        okButton.type = 'button';
        okButton.className = 'btn btn-prim tw:xl:min-w-[8rem]';
        okButton.textContent = 'Continuer';

        var cancelButton = document.createElement('button');
        cancelButton.type = 'button';
        cancelButton.className = 'btn btn-sec tw:border tw:border-solid tw:border-prim tw:xl:min-w-[8rem]';
        cancelButton.textContent = 'Annuler';

        footer.appendChild(cancelButton);
        footer.appendChild(okButton);

        dialog.appendChild(header);
        dialog.appendChild(body);
        dialog.appendChild(footer);

        overlay.appendChild(backdrop);
        overlay.appendChild(dialog);

        var cleanup = (confirmed) => {
            document.removeEventListener('keydown', onKeyDown, true);

            if (searchChangeConfirmationModal) {
                searchChangeConfirmationModal.remove();
                searchChangeConfirmationModal = null;
            }

            resolve(confirmed);
        };

        var onKeyDown = (event) => {
            if (event.key === 'Escape') {
                event.preventDefault();
                cleanup(false);
            }
        };

        closeButton.addEventListener('click', () => cleanup(false));
        cancelButton.addEventListener('click', () => cleanup(false));
        okButton.addEventListener('click', () => cleanup(true));
        backdrop.addEventListener('click', () => cleanup(false));
        dialog.addEventListener('keydown', (event) => {
            if (event.key === 'Tab') {
                var focusableElements = dialog.querySelectorAll('button');
                var firstFocusableElement = focusableElements[0];
                var lastFocusableElement = focusableElements[focusableElements.length - 1];

                if (event.shiftKey && document.activeElement === firstFocusableElement) {
                    event.preventDefault();
                    lastFocusableElement.focus();
                } else if (!event.shiftKey && document.activeElement === lastFocusableElement) {
                    event.preventDefault();
                    firstFocusableElement.focus();
                }
            }
        });

        searchChangeConfirmationModal = overlay;
        document.body.appendChild(overlay);
        document.addEventListener('keydown', onKeyDown, true);
        okButton.focus();
    });
}

function initSearchObjects() {
    var radios = document.querySelectorAll('input[name="search-type"]');
    var checkboxes = document.querySelectorAll('input[name="search-subtype"]');
    var selectedRadio = Array.from(radios).find(radio => radio.checked);

    function hasSelectedFacets() {
        return document.querySelectorAll('.garance-facet .facet-value input:checked').length > 0;
    }

    // ---- 1. Observe le changement des radios ----
    radios.forEach(radio => {
        radio.addEventListener("change", async () => {
            if (hasSelectedFacets() && !(await openSearchChangeConfirmationModal())) {
                radio.checked = false;

                if (selectedRadio) {
                    selectedRadio.checked = true;
                }

                return;
            }

            selectedRadio = radio;

            var newParams = new URLSearchParams();

            if (radio.value !== "all") {
                newParams.set(allowedParams.type, 'com.liferay.object.model.ObjectDefinition#' + radio.value);
            }

            if (originalSearchParameters.get(allowedParams.query)) {
                newParams.append(allowedParams.query, originalSearchParameters.get(allowedParams.query));
            }

            if (originalSearchParameters.get(allowedParams.searchParam)) {
                newParams.append(allowedParams.searchParam, originalSearchParameters.get(allowedParams.searchParam));
            }

            window.location.search = newParams.toString();
        });
    });

    // ---- 2. Observe le changement des checkboxes ----
    checkboxes.forEach(checkbox => {
        checkbox.addEventListener("change", () => {
            setTimeout(() => {

                var newParams = new URLSearchParams();

                // On rajoute le paramètre de type à partir du bouton radio sélectionné
                var radio = Array.from(radios).find(r => r.checked);
                newParams.set(allowedParams.type, 'com.liferay.object.model.ObjectDefinition#' + radio.value)

                // On rajoute les sous-types s'il y en a
                var checkedValues = Array.from(checkboxes).filter(cb => cb.checked).map(cb => cb.value);
                checkedValues.forEach(cb => {
                    newParams.append(allowedParams.subtype, cb);
                })

                if (originalSearchParameters.get(allowedParams.query)) {
                    newParams.append(allowedParams.query, originalSearchParameters.get(allowedParams.query));
                }

                if (originalSearchParameters.get(allowedParams.searchParam)) {
                    newParams.append(allowedParams.searchParam, originalSearchParameters.get(allowedParams.searchParam));
                }

                window.location.search = newParams.toString();
            }, 1000);
        });
    });
}

function initReset() {
    var resetBtn = document.getElementById('search-reset');
    if (resetBtn) {
        resetBtn.addEventListener('click', () => {
            var newParams = new URLSearchParams();
            var type = originalSearchParameters.get(allowedParams.type);
            var query = originalSearchParameters.get(allowedParams.query);
            var searchParameterId = originalSearchParameters.get('searchParameterId');
            if (query !== null) {
                newParams.set(allowedParams.query, query)
            }
            if (type !== null) {
                newParams.set(allowedParams.type, type)
            }
            if (searchParameterId !== null) {
                newParams.set('searchParameterId', searchParameterId)
            }
            window.location.search = newParams.toString();
        })
    }
}

function exportCsv() {
    var checkedArticle = document.querySelectorAll("input.js-export-check:checked");
    var listIds = [];
    checkedArticle.forEach(node => listIds.push(node.id.replace('export-check-', '')));

    var url = `${window.location.origin}/o/csv-exporter-headless/v1.0/Csv`;
    var body = JSON.stringify({"idList": listIds.join(",")});
    console.log(body)
    fetch(url, {
        credentials: 'same-origin',
        method: "POST",
        headers: {
            'content-Type': 'application/json',
        },
        body: body
    })
        .then(async response => {
            if (!response.ok) throw new Error('HTTP ' + response.status);
            if (response.status === 204) return;
            var blob = await response.blob();
            var url = URL.createObjectURL(blob);
            var link = document.createElement('a');
            var filename = 'export.zip';
            link.href = url;
            link.download = filename;
            link.click();
            URL.revokeObjectURL(url);
        }).catch(console.error);
}

function initExport(searchGrid) {
    var checkAll = document.getElementById('export-check-all');
    var checkboxes = searchGrid.querySelectorAll('.js-export-check');
    var exportBtn = document.getElementById("export-button")
    var exportBtnFull = document.getElementById("export-button-full")
    if (exportBtn) {
        var exportBtnLabel = exportBtn.querySelector('.js-export-select-label');
        checkAll.addEventListener('change', e => {
            var checked = 0;
            checkboxes.forEach(c => {
                c.checked = checkAll.checked;
            });
            if (checkAll.checked) {
                exportBtnLabel.innerText = "Exporter " + checkboxes.length + " élément" + ((checkboxes.length > 1) ? "s" : "");
            } else {
                exportBtnLabel.innerText = "Exporter en CSV";
            }
        })
        checkboxes.forEach(c => c.addEventListener('change', e => {
            var checkedInputs = searchGrid.querySelectorAll('.js-export-check:checked')
            if (checkboxes.length === checkedInputs.length && !checkAll.checked) {
                checkAll.checked = true
            } else if (checkboxes.length !== checkedInputs.length && checkAll.checked) {
                checkAll.checked = false
            }
            if (checkedInputs.length > 0) {
                exportBtnLabel.innerText = "Exporter " + checkedInputs.length + " élément" + ((checkedInputs.length > 1) ? "s" : "");
            } else {
                exportBtnLabel.innerText = "Exporter en CSV";
            }
        }));

        if (!exportBtn.classList.contains('is-initialized')) {
            exportBtn.addEventListener('click', e => {
                exportCsv();
            })
            exportBtn.classList.add('is-initialized');
        }
    }
    if (exportBtnFull) {
        exportBtnFull.addEventListener('click', (e) => {
            e.preventDefault();
            var hiddenFullExportBtn = document.getElementById('hidden-full-export-btn');
            if (hiddenFullExportBtn) {
                hiddenFullExportBtn.click();
            }
        })
    }
}

function initSort() {
    var fakeSortInput = document.getElementById('sort-select');
    if (fakeSortInput) {
        if (!fakeSortInput.querySelectorAll('option').length > 0) {
            var originalSort = document.querySelector('.search-grid .lfr-layout-structure-item-com-liferay-portal-search-web-internal-sort-portlet-sortportlet')
            var observer = new MutationObserver((mutations, obs) => {
                var dropdownLoaded = originalSort.querySelector('.dropdown-toggle');

                if (dropdownLoaded) {
                    observer.disconnect();

                    // Quand le bouton de dropdown est chargé, on observe le contenu du dropdown via aria-controls
                    var observerSub = new MutationObserver((mutationsSub, obsSub) => {
                        var noticeType = originalSearchParameters.get(allowedParams.type);
                        var hideDate = false;
                        // Si on est sur toutes les notices ou Personnalité, on masque les dates
                        if (!noticeType || noticeType === 'com.liferay.object.model.ObjectDefinition#' + allowedTypeValues.person) {
                            hideDate = true;
                        }
                        var dropdown = document.getElementById(dropdownLoaded.getAttribute('aria-controls'));
                        if (dropdown) {
                            // Une fois que le sélecteur est chargé, on clone les options
                            var sortLfrLinks = document.getElementById(dropdownLoaded.getAttribute('aria-controls')).querySelectorAll('a.dropdown-item');
                            sortLfrLinks.forEach((sortLfrLink, index) => {
                                var newOption = document.createElement('option');
                                newOption.textContent = sortLfrLink.textContent;
                                if (!hideDate || !sortLfrLink.textContent.toLowerCase().includes('date')) {
                                    newOption.value = index;
                                    fakeSortInput.appendChild(newOption);
                                    if (sortLfrLink.classList.contains('active')) {
                                        fakeSortInput.value = index;
                                    }
                                }
                            });
                        }

                        observerSub.disconnect();

                        fakeSortInput.addEventListener('change', (e) => {
                            var index = e.target.value;
                            if (index !== "") {
                                sortLfrLinks[index].click();
                            }
                        })
                    });
                    observerSub.observe(document.body, {childList: true, subtree: true});
                }
            });
            observer.observe(originalSort, {childList: true, subtree: true});
        }
    }
}


function initSearchDisplay(searchGrid) {
    var searchSwitches = searchGrid.querySelectorAll('.js-display-switch');
    var gridCookie = getCookie('search-display');

    searchSwitches.forEach(searchSwitch => {
        var switchInputs = searchSwitch.querySelectorAll('input');
        var searchResults = searchGrid.querySelector('.search-results');
        var uncheckedValue = ''
        switchInputs.forEach(switchInput => {
            if (switchInput.value === gridCookie) {
                switchInput.checked = true
            } else {
                switchInput.checked = false;
                uncheckedValue = switchInput.value;
            }

            switchInput.addEventListener('change', () => {
                if (switchInput.checked === true) {
                    searchResults.classList.add(switchInput.value + '-gallery');
                    searchResults.classList.remove(searchSwitch.querySelector('input:not(:checked)').value + '-gallery');
                    setCookie("search-display", switchInput.value, 1)
                }
            })
        })

        searchResults.classList.add(gridCookie + '-gallery');
        if (searchResults.classList.contains(uncheckedValue + '-gallery')) {
            searchResults.classList.remove(uncheckedValue + '-gallery');
        }
    })

    initFilters();

    function initFilters() {
        var filtersAccordion = searchGrid.querySelector('#collapse-filtres');
        var filtersAccordionBtn = searchGrid.querySelector('#collapse-filtres-btn');

        if (window.matchMedia('(max-width: 48rem)').matches) {
            filtersAccordionBtn.setAttribute('tabindex', '0')
            filtersAccordionBtn.setAttribute('aria-hidden', 'false')
            if (!filtersAccordion.classList.contains('is-initialized')) {
                filtersAccordionBtn.addEventListener('click', () => {
                    if (filtersAccordionBtn.getAttribute('aria-expanded') == 'true') {
                        closeFiltersAccordion(filtersAccordionBtn, filtersAccordion);
                    } else {
                        openFiltersAccordion(filtersAccordionBtn, filtersAccordion);
                    }
                });
                filtersAccordion.classList.add('is-initialized')
            }
        } else {
            openFiltersAccordion(filtersAccordionBtn, filtersAccordion)
            filtersAccordionBtn.setAttribute('tabindex', '-1')
            filtersAccordionBtn.setAttribute('aria-hidden', 'true')
        }
    }

    window.addEventListener('resize', () => {
        initFilters()
    })

    var filterAccordions = searchGrid.querySelectorAll('.js-filter-accordion');

    filterAccordions.forEach(filterAccordion => {
        var filterAccordionBtn = filterAccordion.querySelector('.js-filter-accordion-btn')
        var filterAccordionBody = filterAccordion.querySelector('.js-filter-accordion-body')

        if (!filterAccordion.classList.contains('is-initialized')) {
            filterAccordionBtn.addEventListener('click', () => {
                if (filterAccordionBtn.getAttribute('aria-expanded') == 'true') {
                    closeFiltersAccordion(filterAccordionBtn, filterAccordionBody);
                } else {
                    openFiltersAccordion(filterAccordionBtn, filterAccordionBody);
                }
            })
            filterAccordion.classList.add('is-initialized')
        }
    })

    var pageNbForm = searchGrid.querySelector('form.js-pagenb-form');
    if (pageNbForm) {
        var pageNbInput = pageNbForm.querySelector('#nb-results');
        if (pageNbInput) {
            if (originalSearchParameters.get('delta')) {
                pageNbInput.value = originalSearchParameters.get('delta');
            }
            pageNbForm.addEventListener('submit', (e) => {
                e.preventDefault();
                var newDelta = 20;
                if (pageNbInput.value) {
                    if (pageNbInput.value > 5000) {
                        newDelta = 5000;
                    } else {
                        newDelta = pageNbInput.value;
                    }
                }
                originalSearchParameters.set("delta", newDelta);
                originalSearchParameters.delete("start");
                window.location.search = originalSearchParameters.toString();
            });
        }
    }

    var dynamicPagination = searchGrid.querySelector('.js-dynamic-pagination');
    if (dynamicPagination) {
        var pageLinks = dynamicPagination.querySelectorAll('a');
        pageLinks.forEach(pl => {
            pl.addEventListener('click', (e) => {
                e.preventDefault();
                var targetPage = pl.dataset.pagenb;
                if (targetPage) {
                    originalSearchParameters.set("start", targetPage);
                    window.location.search = originalSearchParameters.toString();
                }
            })
        })
    }

    function openFiltersAccordion(btn, body) {
        btn.setAttribute('aria-expanded', 'true')
        var accordionLabel = btn.querySelector('.js-filter-accordion-txt');
        var accordionIcon = btn.querySelector('.icon-plus');
        if (accordionLabel) {
            accordionLabel.innerText = 'Tout replier'
        }
        if (accordionIcon) {
            accordionIcon.classList.replace('icon-plus', 'icon-minus')
        }
        if (!body.classList.contains('open')) {
            body.classList.add('open')
        }
    }

    function closeFiltersAccordion(btn, body) {
        btn.setAttribute('aria-expanded', 'false')
        var accordionLabel = btn.querySelector('.js-filter-accordion-txt');
        var accordionIcon = btn.querySelector('.icon-minus');
        if (accordionLabel) {
            accordionLabel.innerText = 'Tout afficher'
        }
        if (accordionIcon) {
            accordionIcon.classList.replace('icon-minus', 'icon-plus')
        }

        if (body.classList.contains('open')) {
            body.classList.remove('open')
        }
    }
}

function setCookie(name, value, days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setDate(date.getDate() + days);
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

function getCookie(name) {
    const cookies = document.cookie.split("; ");

    for (const c of cookies) {
        const [cookieName, cookieValue] = c.split("=");
        if (cookieName === name) {
            return decodeURIComponent(cookieValue);
        }
    }

    return 'list';
}
